import { apiGet, apiUrl, readJsonBody } from './client';

export async function fetchSettlements(): Promise<
  { id: string; name: string; lat?: number; lng?: number }[]
> {
  const data = await apiGet<{ id: string; name: string; lat?: number; lng?: number }[]>(
    '/api/agritour/settlements',
  );
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error('רשימת היישובים ריקה. נסו שוב מאוחר יותר.');
  }
  return data;
}

export async function submitAgriTour(
  formData: FormData,
): Promise<{ success: boolean; mondayItemId: string }> {
  const res = await fetch(apiUrl('/api/agritour/submit'), { method: 'POST', body: formData });
  if (!res.ok) {
    let message = 'שגיאה בשליחת הטופס';
    try {
      const body = await readJsonBody<{ message?: string }>(res);
      if (typeof body.message === 'string' && body.message) {
        message = body.message.includes('should not exist')
          ? 'שגיאה בשליחת הטופס — נסו שוב. אם הבעיה נמשכת, פנו לצוות.'
          : body.message;
      }
    } catch (err) {
      if (err instanceof Error && err.message.includes('HTML')) {
        message = err.message;
      }
    }
    throw new Error(message);
  }
  return readJsonBody<{ success: boolean; mondayItemId: string }>(res);
}
